import ProductForm from '../components/ProductForm';
import FORM_TYPES from '../lib/formTypes';

function NewProductForm() {
  return <ProductForm formType={FORM_TYPES.new} />;
}
export default NewProductForm;
